import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={57}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={56} height={56} x={0.5} fill="#9FEF67" rx={28} />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m23.667 37.886 16.942-16.943a1.333 1.333 0 1 0-1.885-1.886L23.667 34.115l-4.39-4.391a1.333 1.333 0 1 0-1.887 1.886z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckCircle;
